import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOOD_API } from '@config/ws.config';

export interface BogofFreeProduct {
  id: string;
  name: string;
  shop_id: string;
}

export interface BogofRequest {
  trigger_product_id: string;
  trigger_product_shop_id: string;
  order: any;
}

export interface BogofSuggestion {
  promotion_name: string;
  buy_quantity: number;
  free_quantity: number;
  free_products_count_to_add: number;
  free_products: BogofFreeProduct[];
}

/** Product reference in eligible promotions by order API response */
export interface EligiblePromotionProduct {
  id?: string;
  name: string;
  shop_id?: string;
  product_id?: string;
}

/** Promotion item returned by eligible-products-by-order API */
export interface EligiblePromotion {
  title: string;
  type: 'fixed-price-for-products' | 'percentage-discount-on-products' | 'buy-x-get-y-free';
  priority: number;
  products: EligiblePromotionProduct[];
  display_in_promotion_block?: boolean;
  display_label_in_product_block?: boolean;
  allowed_distribution_modes?: string[] | null;
}

/** Product id from eligible payload (`id` or `product_id`). */
export function getEligiblePromotionProductId(ep: EligiblePromotionProduct): string | undefined {
  return ep.id ?? ep.product_id;
}

@Injectable({ providedIn: 'root' })
export class BogofApiService {
  private readonly httpClient = inject(HttpClient);

  /**
   * Get BOGOF (Buy One Get One Free) suggestions for a product.
   * Empty array means no active BOGOF.
   */
  public getBogofSuggestions$(request: BogofRequest) {
    return this.httpClient.post<BogofSuggestion[]>(
      `${DOOD_API}/plugins/revenue-optimization/promotions/bogof-suggest`,
      request,
    );
  }

  /**
   * Get all promotions (fixed price, percentage discount, BOGOF) eligible for the current order.
   * Called when shop is active and when distribution mode changes.
   */
  public getEligibleProductsByOrder$(order: any) {
    return this.httpClient.post<EligiblePromotion[]>(
      `${DOOD_API}/plugins/revenue-optimization/promotions/eligible-products-by-order`,
      { order },
    );
  }
}
